import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';

import Button from '~/shared/components/ButtonsV2';
import Typography from '~/shared/components/Typography';
import DeleteIcon from '~/shared/assets/icons/delete.svg';
import CautionIcon from '~/shared/assets/icons/caution.svg';

interface SkipRoleArnValidationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSkip: () => void;
  isLoading?: boolean;
}

export function SkipRoleArnValidationModal({
  isOpen,
  onClose,
  onSkip,
  isLoading = false,
}: SkipRoleArnValidationModalProps) {
  return (
    <Dialog open={isOpen} as="div" className="relative z-[99] focus:outline-none" onClose={onClose}>
      <div className="fixed inset-0 w-screen overflow-y-auto bg-[#00000059] backdrop-blur-[6px]">
        <div className="flex min-h-screen items-center justify-center">
          <DialogPanel
            transition
            className="flex my-auto w-full max-w-[689px] flex-col rounded-xl bg-white backdrop-blur-2xl duration-300 ease-out overflow-hidden data-closed:transform-[scale(95%)] data-closed:opacity-0 "
          >
            <div className="flex flex-col w-full items-center">
              <div className="flex flex-col w-full items-center px-12 pt-9 pb-6">
                <div className="w-8 mb-4.5">
                  <CautionIcon className="size-9 text-carrot-orange" />
                </div>
                <DialogTitle
                  as="h3"
                  className="text-2xl 2xl:text-[24px] font-[500] mb-[10px] text-center font-family-outfit leading-6"
                >
                  Invalid IAM Role
                </DialogTitle>
                <Typography variant="p3" className="max-w-[593px] text-center font-family-inter">
                  The IAM role defined by the ARN does not have the required permissions, or could
                  not be validated due to an SCP or other restriction.
                  <br />
                  Do you wish to skip the validation and insert the role anyway?
                </Typography>
              </div>

              <div className="flex items-center justify-center gap-3 w-full py-6">
                <Button
                  variant="primary"
                  className="w-[152px] h-[44px]"
                  onClick={onClose}
                  disabled={isLoading}
                >
                  <Typography variant="p3" color="text-white">
                    No, cancel
                  </Typography>
                </Button>
                <Button
                  variant="third"
                  className="w-47.5 h-11"
                  onClick={onSkip}
                  loading={isLoading}
                  disabled={isLoading}
                >
                  <Typography variant="p3" color="text-primary-900 ">
                    Yes, skip validation
                  </Typography>
                </Button>
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
